const OrderActions = {
  ORDER_TYPE: "ORDER_TYPE",
};

export default OrderActions;
